<div>
  <div class="container-fluid eq-page">
    <div id="main-container row">
      <div id="logo" class="col-md-4 col-xs-12 col-sm-5 logo pull-left">
        <img src="assets/images/llwr.png" class="menu" />
      </div>
      <div class="col-md-8 col-xs-12 col-sm-7  pull-right log-div">
        <div id="spnUser" class="pull-right">
          <div>
            <span style="font-size:12px;padding-right: 10px;"> Welcome</span>
            <span class="welcome">{{auth.loginData.Firstname}}</span>
          </div>
          <p class="pull-right">
            <button type="submit" class=" btn-logout" (click)='logout()'>Log out</button>
          </p>
        </div>
      </div>
    </div>
  </div>
  <div>
    <button #menuBtn type="button" (click)="toggleMenu()" class="hamburger" data-toggle="offcanvas">
    </button>
  </div>

  <div #wrapper id="wrapper">
    <!-- Sidebar -->
    <nav class="menu-bar clear" id="sidebar-wrapper" role="navigation">
      <div class="bs-example">
        <ngu-accordion>
          <ngu-accordion-body *ngFor="let nav of navLists; let i = index">
            <ngu-accordion-header>
              <span class="text">{{nav.title}}</span>
            </ngu-accordion-header>
            <div>
              <p *ngFor="let chil of nav.child" (click)="menuClicked()">
                <a *ngIf="chil.externalurl; else externalurl" [href]="hostNameUrl+'/'+chil.url+associatedId" [target]="chil.isNewPage ? '_blank' : '_self'">{{chil.title}}</a>
                <ng-template #externalurl>
                  <a [routerLink]="'/'+nav.url+'/'+chil.url" (click)="clearStorage()" *ngIf="chil.title == 'Templates Master'? false :  chil.title == 'Email Queue'? false : chil.title == 'Email Log' ? false : true ">{{chil.title}}</a>
                </ng-template>
              </p>
            </div>
          </ngu-accordion-body>
        </ngu-accordion>
      </div>
    </nav>
    <div class="navOverlay" *ngIf="menuState === 'in'" (click)="toggleMenu()"></div>
  </div>
</div>

<!-- <div class="panel-group" id="accordion" #accord>
  <div class="panel panel-default" *ngFor="let nav of navLists | roleFilter; let i = index">
    <div class="panel-heading">
      <h4 class="panel-title">
        <a data-toggle="collapse" data-parent="#accordion" href="#collapse{{i}}">
          <span class="ui-icon ui-icon-circle-arrow-e"></span>
          <span class="text">{{nav.title}}</span>
        </a>
      </h4>
    </div>
    <div id="collapse{{i}}" class="panel-collapse collapse">
      <div class="panel-body">
        <div class="ui-accordion-content ui-helper-reset ui-widget-content ui-corner-bottom ui-accordion-content-active" role="tabpanel">
          <p *ngFor="let chil of nav.child">
            <a [routerLink]="'/'+nav.url+'/'+chil.url">{{chil.title}}</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</div> -->
